import { use } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { Header } from '~/components';

import { SettingsHeaderActionsPortalContext } from './SettingsHeader.context';
import { saveActionStyle } from './SettingsSaveAction.css';

type Props = {
  isDirty: boolean;
  isSaving: boolean;
  onSave: () => void;
};

export const SettingsSaveAction = ({ isDirty, isSaving, onSave }: Props) => {
  const headerActionsPortal = use(SettingsHeaderActionsPortalContext);

  const { t } = useTranslation(['settings']);

  if (!headerActionsPortal) return null;

  // The whole `Header.Actions` is portalled, not just the action, because the floating action finds its portal through context.
  return createPortal(
    <Header.Actions>
      {isDirty && (
        <Header.Action className={saveActionStyle} icon="Save" loading={isSaving} onClick={onSave}>
          {t('settings:header.save')}
        </Header.Action>
      )}
    </Header.Actions>,
    headerActionsPortal,
  );
};
